export function parseHtmlToAst(html) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  const ast = [];

  doc.body.childNodes.forEach((node) => {
    if (node.nodeType === Node.ELEMENT_NODE) {
      const tag = node.tagName.toLowerCase();

      switch (tag) {
        case "p":
          ast.push({
            type: "paragraph",
            content: parseInlineContent(node),
          });
          break;

        case "h1":
        case "h2":
        case "h3":
        case "h4":
        case "h5":
        case "h6":
          ast.push({
            type: "heading",
            attrs: { level: parseInt(tag[1], 10) },
            content: parseInlineContent(node),
          });
          break;

        case "ul":
          ast.push(parseList(node, "bulletList"));
          break;

        case "ol":
          ast.push(parseList(node, "orderedList"));
          break;

        case "aside":
          ast.push({
            type: "infobox",
            content: parseChildBlocks(node),
          });
          break;

        case "img":
          ast.push({
            type: "image",
            attrs: {
              src: node.getAttribute("src") || "",
              alt: node.getAttribute("alt") || "",
            },
          });
          break;

        default:
          ast.push({
            type: "paragraph",
            content: parseInlineContent(node),
          });
      }

    } else if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
      ast.push({
        type: "paragraph",
        content: [
          {
            type: "text",
            text: typeof node.textContent === "string" && node.textContent.length ? node.textContent.trim() : " "
          },
        ],
      });
    }
  });

  return ast;
};

function parseInlineContent(element) {
  const nodes = [];

  element.childNodes.forEach((child) => {
    if (child.nodeType === Node.TEXT_NODE) {
      if (child.textContent.trim()) {
        nodes.push({
          type: "text",
          text: typeof child.textContent === "string" && child.textContent.length ? child.textContent : " "
        });
      }
    } else if (child.nodeType === Node.ELEMENT_NODE) {
      let marks = [];
      if (["strong", "b"].includes(child.tagName.toLowerCase())) {
        marks.push({ type: "bold" });
      }
      if (["em", "i"].includes(child.tagName.toLowerCase())) {
        marks.push({ type: "italic" });
      }
      if (child.tagName.toLowerCase() === "a" && child.hasAttribute("href")) {
        marks.push({
          type: "link",
          attrs: { href: child.getAttribute("href") }
        });
      }

      nodes.push({
        type: "text",
        text: typeof child.textContent === "string" && child.textContent.length ? child.textContent : " ",
        marks,
      });
    }
  });

  return nodes;
}

function parseList(node, listType) {
  const items = [];

  node.querySelectorAll("li").forEach((li) => {
    items.push({
      type: "listItem",
      content: [
        {
          type: "paragraph",
          content: parseInlineContent(li),
        },
      ],
    });
  });

  return {
    type: listType,
    content: items,
  };
}